var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDBinsightaiHorizonlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 76.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b3fb2;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#57dfff;}.cls-3{fill:#0f1027;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m66.82,25.13c0-1.17.92-2.09,2.09-2.09s2.06.92,2.06,2.09-.92,2.09-2.06,2.09-2.09-.92-2.09-2.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 67.25,
    y: 29.31,
    width: 3.26,
    height: 15.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.96,36.27c0-2.89-1.57-4.38-3.95-4.38s-3.98,1.49-3.98,4.38v8.82h-3.26v-15.77h3.26v1.8c1.06-1.29,2.81-2.06,4.69-2.06,3.69,0,6.47,2.32,6.47,6.73v9.3h-3.23v-8.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m96.89,45.34c-3.78,0-6.44-2.23-6.58-5.09h3.38c.11,1.29,1.35,2.35,3.15,2.35s2.89-.8,2.89-1.89c0-3.09-9.16-1.32-9.16-7.1,0-2.52,2.35-4.55,6.07-4.55s5.93,1.92,6.1,5.07h-3.26c-.11-1.37-1.17-2.32-2.95-2.32s-2.66.72-2.66,1.77c0,3.18,8.9,1.4,9.07,7.1,0,2.66-2.32,4.67-6.04,4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m104.92,25.13c0-1.17.92-2.09,2.09-2.09s2.06.92,2.06,2.09-.92,2.09-2.06,2.09-2.09-.92-2.09-2.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 105.35,
    y: 29.31,
    width: 3.26,
    height: 15.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m118.15,29.06c2.58,0,4.49,1.2,5.47,2.55v-2.29h3.29v16.03c0,4.29-2.78,7.53-7.7,7.53-4.21,0-7.33-2.09-7.73-5.58h3.23c.49,1.63,2.23,2.75,4.49,2.75,2.52,0,4.41-1.55,4.41-4.69v-2.63c-1,1.35-2.89,2.63-5.47,2.63-4.15,0-7.44-3.35-7.44-8.21s3.29-8.07,7.44-8.07Zm.69,2.83c-2.43,0-4.78,1.83-4.78,5.24s2.35,5.38,4.78,5.38,4.78-1.92,4.78-5.32-2.32-5.3-4.78-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m129.67,23.9h3.26v7.24c1.09-1.32,2.86-2.09,4.89-2.09,3.52,0,6.27,2.32,6.27,6.73v9.3h-3.23v-8.82c0-2.89-1.57-4.38-3.95-4.38s-3.98,1.49-3.98,4.38v8.82h-3.26v-21.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m146.97,31.98h-1.86v-2.66h1.86v-3.92h3.29v3.92h3.84v2.66h-3.84v8.73c0,1.17.46,1.66,1.83,1.66h2v2.72h-2.58c-2.8,0-4.55-1.17-4.55-4.38v-8.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m158.42,45.29c-1.17,0-2.09-.92-2.09-2.09s.92-2.09,2.09-2.09,2.06.92,2.06,2.09-.92,2.09-2.06,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m168.82,29.06c2.66,0,4.49,1.26,5.47,2.55v-2.29h3.29v15.77h-3.29v-2.35c-1,1.35-2.89,2.6-5.52,2.6-4.09,0-7.39-3.35-7.39-8.21s3.29-8.07,7.44-8.07Zm.69,2.83c-2.43,0-4.78,1.83-4.78,5.24s2.35,5.38,4.78,5.38,4.78-1.92,4.78-5.32-2.32-5.3-4.78-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m180.03,25.13c0-1.17.92-2.09,2.09-2.09s2.06.92,2.06,2.09-.92,2.09-2.06,2.09-2.09-.92-2.09-2.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 180.46,
    y: 29.31,
    width: 3.26,
    height: 15.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m48.22,31.51c0,8.52-5.81,13.73-14.69,13.73h-9.04v-27.67h9.04c8.88,0,14.69,5.37,14.69,13.93Zm-14.69,10.03c6.53,0,10.03-3.74,10.03-10.03s-3.5-10.23-10.03-10.23h-4.5v20.26h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.9,45.25h-11.07v-27.67h10.55c5.85,0,8.96,3.22,8.96,7.13,0,3.34-2.03,5.37-4.7,6.33,2.95.52,5.33,3.46,5.33,6.77,0,4.22-3.42,7.44-9.08,7.44Zm-.92-23.97h-5.61v7.92h5.61c2.95,0,4.74-1.39,4.74-3.94s-1.79-3.98-4.74-3.98Zm.36,11.62h-5.97v8.64h6.13c3.07,0,4.94-1.55,4.94-4.22s-2.07-4.42-5.1-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.35,31.51c0,8.52-5.81,13.73-14.69,13.73h-9.04v-27.67h9.04c8.88,0,14.69,5.37,14.69,13.93Zm-14.69,10.03c6.53,0,10.03-3.74,10.03-10.03s-3.5-10.23-10.03-10.23h-4.5v20.26h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53.02,45.25h-11.07v-27.67h10.55c5.85,0,8.96,3.22,8.96,7.13,0,3.34-2.03,5.37-4.7,6.33,2.95.52,5.33,3.46,5.33,6.77,0,4.22-3.42,7.44-9.08,7.44Zm-.92-23.97h-5.61v7.92h5.61c2.95,0,4.74-1.39,4.74-3.94s-1.79-3.98-4.74-3.98Zm.36,11.62h-5.97v8.64h6.13c3.07,0,4.94-1.55,4.94-4.22s-2.07-4.42-5.1-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.98,31.51c0,8.52-5.81,13.73-14.69,13.73h-9.04v-27.67h9.04c8.88,0,14.69,5.37,14.69,13.93Zm-14.69,10.03c6.53,0,10.03-3.74,10.03-10.03s-3.5-10.23-10.03-10.23h-4.5v20.26h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m50.91,45.25h-11.07v-27.67h10.55c5.85,0,8.96,3.22,8.96,7.13,0,3.34-2.03,5.37-4.7,6.33,2.95.52,5.33,3.46,5.33,6.77,0,4.22-3.42,7.44-9.08,7.44Zm-.92-23.97h-5.61v7.92h5.61c2.95,0,4.74-1.39,4.74-3.94s-1.79-3.98-4.74-3.98Zm.36,11.62h-5.97v8.64h6.13c3.07,0,4.94-1.55,4.94-4.22s-2.07-4.42-5.1-4.42Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.39,54.35c2.99,0,5.26,2.23,5.26,5.69s-2.29,5.77-5.26,5.77c-2.02,0-3.46-1.01-4.15-2.23v2.04h-1.84v-14.97h1.84v5.95c.71-1.23,2.19-2.25,4.15-2.25Zm-.38,1.6c-2,0-3.76,1.54-3.76,4.11s1.76,4.13,3.76,4.13,3.76-1.54,3.76-4.15-1.72-4.09-3.76-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.86,65.81c-3.16,0-5.48-2.23-5.48-5.75s2.25-5.71,5.48-5.71,5.32,2.27,5.32,5.3c0,.4-.02.73-.06,1.11h-8.86c.14,2.25,1.72,3.48,3.6,3.48,1.66,0,2.71-.85,3.12-2.04h1.98c-.57,2.02-2.35,3.6-5.1,3.6Zm-3.58-6.54h7c.02-2.17-1.6-3.36-3.5-3.36-1.8,0-3.3,1.19-3.5,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.01,56.05h-1.44v-1.52h1.44v-2.79h1.84v2.79h2.89v1.52h-2.89v6.54c0,1.09.4,1.48,1.54,1.48h1.36v1.56h-1.66c-1.96,0-3.08-.81-3.08-3.04v-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m105.54,54.35c2.06,0,3.48,1.05,4.13,2.21v-2.02h1.86v11.09h-1.86v-2.06c-.67,1.19-2.1,2.25-4.15,2.25-2.95,0-5.24-2.33-5.24-5.77s2.29-5.69,5.26-5.69Zm.36,1.6c-2.02,0-3.74,1.48-3.74,4.09s1.72,4.15,3.74,4.15,3.76-1.52,3.76-4.13-1.74-4.11-3.76-4.11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDBinsightaiHorizonlogo);
export default __webpack_public_path__ + "static/media/DBinsightai-Horizonlogo.0ab5c8726df0604391347160abd7c6f0.svg";
export { ForwardRef as ReactComponent };